/* eslint-disable unicorn/filename-case */
const DIGIT_INDICATOR = 'd';
const ALPHA_INDICATOR = 'a';
const CONSTANT_PATTERN = /[\s#()-/]/g;
const DIGIT_CHAR_PATTERN = /\d/;
const ALPHA_CHAR_PATTERN = /[A-Za-z]/;

const isDigitChar = char => DIGIT_CHAR_PATTERN.test(char);

const isAlphaChar = char => ALPHA_CHAR_PATTERN.test(char);

const isPlaceholderDigit = (indicator, char) => indicator === DIGIT_INDICATOR && isDigitChar(char);

const isPlaceholderAlpha = (indicator, char) => indicator === ALPHA_INDICATOR && isAlphaChar(char); // global regular expressions have state, resulting in inconsistent behavior, resetting their inner
// state makes them execute consistently


const resetConstantPattern = () => CONSTANT_PATTERN.lastIndex = 0;

const removeNonAlphaNumericCharacters = input => typeof input === 'string' ? input.replace(/[^\dA-Za-z]/g, '') : input;

const isConstant = char => {
  resetConstantPattern();
  return CONSTANT_PATTERN.test(char);
};

var stringFormat = ((input, mask) => {
  const value = typeof input === 'number' ? input.toString() : removeNonAlphaNumericCharacters(input);
  let valueIndex = 0;
  let result = '';

  for (let i = 0; i < mask.length && (value === null || value === void 0 ? void 0 : value.length); i += 1) {
    const maskIndicator = mask[i];
    const nextCharacter = value[valueIndex];
    const constantMatch = isConstant(maskIndicator);
    const placeholderMatch = isPlaceholderAlpha(maskIndicator, nextCharacter) || isPlaceholderDigit(maskIndicator, nextCharacter);

    if (nextCharacter === undefined && !constantMatch) {
      break;
    }

    if (constantMatch) {
      result += maskIndicator; // Add constant character to result if found
    } else {
      valueIndex += 1;

      if (placeholderMatch) {
        result += nextCharacter; // Add matching placeholder to result if found
      } else {
        // Neither constant nor matching placeholder found,
        // Recheck this index of mask using next index of the value
        i -= 1;
      }
    }
  }

  return result;
});

export { stringFormat as default };
